// @flow

import * as React from "react";

import type { TaskType } from "../../data/tasks";

import "./task.css";

const task = {
  prompt:
    "What is the probability that the quantity on the right is bigger (in %)?",
  confidenceLabels: {
    left: "Left is definitely bigger",
    middle: "No idea",
    right: "Right is definitely bigger"
  },
  answerText: {
    false: "Left is bigger.",
    true: "Right is bigger."
  },
  renderQuestion(task: TaskType): React.Node {
    const [left, right] = task.question.split(" < ");
    return (
      <div className="Fermi-Container">
        <div className="Fermi-Block Fermi-Text Fermi-Text-Left" />
        <div className="Fermi-Block Fermi-Quantity Fermi-Quantity-Left">
          {left}
        </div>
        <div className="Fermi-Block Fermi-Text Fermi-Text-Middle" />
        <div className="Fermi-Block Fermi-Quantity Fermi-Quantity-Right">
          {right}
        </div>
        <div className="Fermi-Block Fermi-Text Fermi-Text-Right" />
      </div>
    );
  },
  tools: {
    scratchpad: true
  }
};

export default task;



// WEBPACK FOOTER //
// ./src/templates/fermi/task.js